export default "__VITE_ASSET__3PyRPUA1__"